import { createMuiTheme } from '@material-ui/core/styles';

const paymenttheme = createMuiTheme({
    overrides: {
        MuiTab: {
            wrapper: {
                padding: '10px 20px'
            }
        },
        MuiTabs:{
            root :{
                '&:first-child':{
                    marginRight:'unset !important',
                   },
                   background: '#0E3E73',
                   borderBottomLeftRadius:'12px', 
                    borderTopLeftRadius:'12px',
                    color:'white',
                    marginBottom: 'unset !important',
                    width: 'auto',
            }
        },
        PrivateTabIndicator:{
            root:{
                backgroundColor:'#EEF6FF !important',
            }
        }
    }
});

export default paymenttheme;
